"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LiteralValue = void 0;
const Expression_1 = require("./Expression");
/**
 * Represents a literal value expression.
 *
 * @template T The input type of the expression.
 * @template R The output type of the expression, defaulting to number.
 * @param {R} _value The literal value to be returned when executed.
 */
class LiteralValue extends Expression_1.Expression {
    constructor(_value) {
        super();
        this._value = _value;
    }
    /**
     * Executes the literal value expression and returns the value.
     *
     * @param {T} obj The object on which the expression is executed (not used in this case).
     * @returns {R} The literal value.
     */
    execute(obj) {
        return this._value;
    }
}
exports.LiteralValue = LiteralValue;
